import { Image } from 'antd';
import styles from './PageLoader.module.css';

const PageLoader = () => {
  return (
    <div className={styles.PageLoader}>
      <Image src="/loader.gif" width={50} height={50} alt="Loading" />
    </div>
  );
};

export default PageLoader;
